import { MatchmakingTrack } from "model/Match/Set/Matchmaking/Track/MatchmakingTrack";
import { getMatchSetWinnerIds, MatchSet } from "model/Match/Set/MatchSet";

// todo - rename? or maybe includes stuff like numWinners?
export type FsMatchFormat = {
  type: string | undefined;
  setAdvantageRosterIds: string[] | undefined;
  tiebreakerSet: boolean | undefined;
  amount: number | undefined;

  setPoints?: FsSetPoints;
};

export type FsSetPoints = {
  points: number[];
  bonus?: {
    type: "RP";
    tie?: {
      type: "Set";
      num: 3;
    };
  };
};

export const getRoundPointsBonusRosterId = (
  sets: MatchSet[],
  tiebreakerSetNum: number | undefined
) => {
  const totalRoundPoints: { [rosterId: string]: number } = {};
  for (let i = 0; i < sets.length; i++) {
    const set = sets[i];
    for (let t = 0; t < set.tracks.length; t++) {
      const track = set.tracks[t] as MatchmakingTrack;
      if (!track.scores) {
        continue;
      }

      const rosterIds = Object.keys(track.scores);
      rosterIds.forEach(
        (id) =>
          (totalRoundPoints[id] =
            (totalRoundPoints[id] ?? 0) + (track.scores![id] ?? 0))
      );
    }
  }

  const maxRoundPoints = Math.max(...Object.values(totalRoundPoints), 0);
  if (maxRoundPoints === 0) {
    return undefined;
  }

  const rostersOnMax = Object.keys(totalRoundPoints).filter(
    (id) => totalRoundPoints[id] === maxRoundPoints
  );
  if (rostersOnMax.length === 1) {
    return rostersOnMax[0];
  }

  const tiebreakerSet =
    tiebreakerSetNum !== undefined ? sets.at(tiebreakerSetNum - 1) : undefined;
  if (!tiebreakerSet) {
    return undefined;
  }

  const setWinners = getMatchSetWinnerIds(tiebreakerSet);
  if (!setWinners || setWinners.length > 1) {
    return undefined;
  }

  return setWinners[0];
};
